import React from 'react';
import { useSelector } from 'react-redux';

import { GET_PLAN_ID } from 'common/modules/domain/plan';
import { UserInformation } from 'common/modules/domain/user';
import { FetchState, FetchStatus } from 'common/modules/app/fetch';
import { ErrorState } from 'common/modules/app/errors';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { VALUE_DUMMY_REGION } from 'common/utils/cookie-utils';
import { AppState } from 'pages';
import {
  PlanDetailMessage,
  MESSAGE_TYPES_KEY
} from 'pages/plan-detail/components/PlanDetailMessage';

/** Stateからエラーメッセージ用のPropsに変換する */
const _convertMessageProps = (
  userState: UserInformation,
  fetchState: FetchState,
  errorState: ErrorState
): { show: boolean; messageType?: MESSAGE_TYPES_KEY } => {
  // 対象プラン取得前は表示なし
  if (
    fetchState[GET_PLAN_ID] !== FetchStatus.UNTREATED &&
    fetchState[GET_PLAN_ID] !== FetchStatus.FAILED
  ) {
    return { show: false };
  }
  // 対象プラン取得で400以外のエラーが起きたときだけ表示
  // 400はNotFoundエラー画面遷移
  if (errorState.requestId === GET_PLAN_ID && errorState.statusCode === 404) {
    return { show: true, messageType: 'notFoundError' };
  }
  if (errorState.requestId === GET_PLAN_ID && errorState.statusCode !== 400) {
    return { show: true, messageType: 'otherError' };
  }
  // プラン詳細画面で国が選択されていなければ、国地域未選択と判断してメッセージを表示
  // (countryが空又はdummyが指定されている場合は未選択と判断)
  const country = userState.country;
  if (!country || country === VALUE_DUMMY_REGION) {
    return { show: true, messageType: 'notSelectedCountry' };
  }
  return { show: false };
};

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );
  const errorState = useSelector<AppState, ErrorState>(
    (state) => state.app.error
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );

  return {
    ..._convertMessageProps(userState, fetchState, errorState),
    glossary: Glossary.instance(glState)
  };
};

/**
 * プラン詳細に表示するエラーメッセージのContainer Component
 */
export default function ContainerComponent() {
  const _props = useStateProps();
  return <PlanDetailMessage {..._props} />;
}
